var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.display &&
    ["postCreator", "posts2", "planner"].includes(_vm.$route.name) &&
    (!_vm.isProd() || _vm.activeFrontV2)
    ? _c(
        "div",
        {
          staticClass: "switch-version-modal",
          class: {
            newInterface: ["postCreator", "posts2"].includes(_vm.$route.name),
          },
        },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("dash.posts.modal-switch.title"))),
              ]),
              _c("ComponentSwitch", {
                attrs: {
                  value: _vm.version == "beta",
                  onChange: _vm.switchVersion,
                },
              }),
            ],
            1
          ),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("dash.posts.modal-switch.description"))),
          ]),
          _c("div", { staticClass: "buttons" }, [
            _c(
              "div",
              {
                staticClass: "btn btn-secondary",
                on: { click: _vm.hideAllTime },
              },
              [_vm._v(_vm._s(_vm.$t("dash.posts.modal-switch.hide")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function ($event) {
                    _vm.display = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("dash.button.close")))]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }